import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { SessaoService } from './sessao.service';
import { EnderecoContrato } from '../modelo/enderecoContrato';
import { CopiaContrato } from '../modelo/copiaContrato';
import 'rxjs/add/operator/mergeMap';
import { CopiaContratoNewSpaceOrquestradora } from '../modelo/copiaContratoNewSpaceOrquestradora';


@Injectable()
export class CopiaContratoService {

  static download(fileName: string, data: string) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
      data = data.replace(/\s/g, "");
      data = data.replace(/^[^,]+,/, '');

      var byteString = atob(data);
      var buffer = new ArrayBuffer(byteString.length);
      var intArray = new Uint8Array(buffer);
      
      for (var i = 0; i < byteString.length; i++) {
          intArray[i] = byteString.charCodeAt(i);
      }

      var blob = new Blob([buffer], {type: "application/pdf"});

      window.navigator.msSaveOrOpenBlob(blob, fileName + '.pdf');
    } else {
      var sliceSize = 512;

      var byteCharacters = atob(data);
      var byteArrays = [];
  
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
  
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
  
        var byteArray = new Uint8Array(byteNumbers);
  
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: 'application/pdf'});

      const link = document.createElement('a');
      link.download = fileName  + '.pdf';
      link.href = window.URL.createObjectURL(blob);
      link.click();

      setTimeout(function(){window.URL.revokeObjectURL(data)}, 100);
    }
  }

  constructor(
    private restClient: RestClientService,
    private sessaoService: SessaoService,
) { }

listarContrato(): Observable<EnderecoContrato> {
  let resourcePath = Config.COPIACONTRATO_PATH + '/listarContrato';
  resourcePath += '/nuCTRL/' + this.sessaoService.sessao.autenticado.nuCTRL;

  return this.restClient.getResource(resourcePath).map(response => response.json());
}

recuperarContrato(nuContrato: number, nuCarteira: number): Observable<CopiaContrato> {
  let resourcePath = Config.COPIACONTRATO_PATH + '/recuperarContrato';
  resourcePath += '/nuCTRL/' + this.sessaoService.sessao.autenticado.nuCTRL;
  resourcePath += '/nuContrato/' + nuContrato;
  resourcePath += '/nuCarteira/' + nuCarteira;
  return this.restClient.getResourceTimeout(resourcePath).map(response => response.json());
}

recuperarContratoNew(numeroContrato: string, dataBase: string):Observable<CopiaContratoNewSpaceOrquestradora> {
  let resourcePath = Config.COPIACONTRATO_PATH + '/recuperarContratoNew';
  resourcePath += "/" + numeroContrato;
  if(dataBase != null || dataBase != "") {
    resourcePath += '?dataBase=' + dataBase;
  }
  return this.restClient.getResourceTimeout(resourcePath).map(response => response.json());
}



static downloadOrquestradora(fileName: string, data: string) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
      data = data.replace(/\s/g, "");
      data = data.replace(/^[^,]+,/, '');

      var byteString = atob(data);
      var buffer = new ArrayBuffer(byteString.length);
      var intArray = new Uint8Array(buffer);
      
      for (var i = 0; i < byteString.length; i++) {
          intArray[i] = byteString.charCodeAt(i);
      }

      var blob = new Blob([buffer], {type: "application/pdf"});

      window.navigator.msSaveOrOpenBlob(blob, fileName + '.pdf');
    } else {
      var sliceSize = 512;

      var byteCharacters = atob(data);
      var byteArrays = [];
  
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
  
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
  
        var byteArray = new Uint8Array(byteNumbers);
  
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: 'application/pdf'});

      const link = document.createElement('a');
      link.download = fileName  + '.pdf';
      link.href = window.URL.createObjectURL(blob);
      link.click();

      setTimeout(function(){window.URL.revokeObjectURL(data)}, 100);
    }
  }
}





// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/copiacontrato.service.ts